import React, { useState, useEffect, useRef } from 'react';
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  Button,
  DropdownItem,
  Image,
} from '@nextui-org/react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import '../../../styles/custom-quill-toolbar.css';
import { message, Spin } from 'antd';
import { PrivateAxiosInstance } from '../../../services/createAxiosInstance';
import { URLs } from '../../../constants/apiEndpoints';
import FileuploadInput from '../../../components/FileuploadInput/FileuploadInput';
import { useNavigate, useParams } from 'react-router-dom';

function EditMarketAnalysis() {
  const [loading, setLoading] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState('');
  const [showImage, setShowImage] = useState('');
  const [formData, setFormData] = useState({
    articleName: '',
    description: '',
    status: null,
    image: null,
  });

  const editorRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  console.log('showImage: ', showImage);
  const getArticleById = async () => {
    try {
      const res = await PrivateAxiosInstance.get(
        `${URLs.GET_SINGLE_ARTICLE}/${id}`
      );
      const article = res?.data?.article;
      setFormData(article);
      setShowImage(article.image[0].url);
      setSelectedKeys(article.status == true ? 'community' : 'market');
    } catch (error) {
      message.error('Error fetching article');
      console.error('Fetch article error: ', error);
    }
  };

  useEffect(() => {
    getArticleById();
  }, [id]);

  useEffect(() => {
    // Initialize Quill editor
    if (editorRef.current && !editorRef.current.__quill) {
      const quill = new Quill(editorRef.current, {
        theme: 'snow',
        modules: {
          toolbar: [
            [{ header: '1' }, { header: '2' }, { header: '3' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['link'],
          ],
        },
      });

      quill.on('text-change', () => {
        const descriptionContent = quill.root.innerHTML;
        setFormData((prevData) => ({
          ...prevData,
          description: descriptionContent,
        }));
      });

      editorRef.current.__quill = quill; // Mark editor as initialized
    }
  }, []); // Run only once

  useEffect(() => {
    // Update Quill content after fetching data
    if (
      editorRef.current &&
      editorRef.current.__quill &&
      formData.description
    ) {
      const quill = editorRef.current.__quill;
      quill.root.innerHTML = formData.description;
    }
  }, [formData.description]); // Run whenever description changes

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataToSend = new FormData();
    if (selectedKeys === 'community') {
      formDataToSend.append('status', true);
    } else {
      formDataToSend.append('status', false);
    }

    formDataToSend.append('articleName', formData.articleName);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('files', formData.image);

    formDataToSend.forEach((element) => {
      console.log('Submit Articles: ', element);
    });

    try {
      await PrivateAxiosInstance.put(
        `${URLs.UPDATE_ARTICLE}/${id}`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      message.success('Article Edit Successfully');
      setFormData({ articleName: '', description: '', image: null });
      navigate('/admin/market-analysis/all');
    } catch (error) {
      console.error('Article edit error:', error);
      message.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const { files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      image: files[0],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelect = (key) => {
    setSelectedKeys(key);
  };

  return (
    <section className="bg-background-primary-color">
      <Spin spinning={loading} fullscreen />
      <div className="flex flex-col items-center justify-center mt-20 mb-20 mx-auto lg:py-0">
        <div className="w-full bg-gray-800 rounded-lg shadow  md:min-w-[800px] lg:min-w-[1000px] md:mt-0 sm:max-w-md xl:p-0 ">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-poppins font-bold leading-tight tracking-tight text-white">
              Create a new Article
            </h1>
            <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
              <label
                htmlFor="articleName"
                className="block -mb-2 text-sm font-poppins font-medium text-gray-200"
              >
                Select type
              </label>
              <Dropdown>
                <DropdownTrigger>
                  <Button
                    variant="solid"
                    className="text-md font-poppins bg-btn-color font-normal text-black"
                  >
                    {selectedKeys === 'market'
                      ? 'Market Analysis'
                      : 'Community Article'}
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  color="success"
                  aria-label="Static Actions"
                  onAction={handleSelect}
                >
                  <DropdownItem key="market">Market Analysis</DropdownItem>
                  <DropdownItem key="community">Community Article</DropdownItem>
                </DropdownMenu>
              </Dropdown>

              <div>
                <label
                  htmlFor="articleName"
                  className="block mb-2 text-sm font-poppins font-medium text-white"
                >
                  Title
                </label>
                <input
                  type="text"
                  id="articleName"
                  name="articleName"
                  value={formData.articleName}
                  onChange={handleChange}
                  className="block font-normal  w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-sm focus:ring-blue-500 focus:border-blue-500 "
                />
              </div>

              <label
                htmlFor="description"
                className="block mb-2 font-poppins text-sm font-medium text-white"
              >
                Description
              </label>

              <div
                className="bg-white text-black text-md h-96 rounded-lg"
                ref={editorRef}
              />

              <label
                htmlFor="image"
                className="font-poppins block mb-1 text-sm font-medium text-white"
              >
                Old cover image
              </label>

              <Image
                // width={100}
                alt="article image"
                src={showImage}
              />

              <div>
                <label
                  htmlFor="image"
                  className="font-poppins block mb-1 text-sm font-medium text-white"
                >
                  Upload new cover image
                </label>

                <FileuploadInput
                  name="image"
                  accept="image/jpeg,image/png"
                  onChange={handleFileChange}
                />
              </div>

              <div className="flex item-center justify-between">
                <button
                  type="submit"
                  className="flex justify-center font-poppins w-[100px] text-black bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                >
                  Edit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EditMarketAnalysis;
